function getQueryParam(name) {
    const url = new URL(window.location.href);

    const fromSearch = new URLSearchParams(url.search).get(name);

    if (fromSearch !== null) return fromSearch;

    const hash = url.hash || '';
    const qIndex = hash.indexOf('?');
    if (qIndex !== -1) {
        const hashParams = new URLSearchParams(hash.slice(qIndex + 1));
        return hashParams.get(name);
    }

    return null;
}

async function getJwtToken(uuid) {
    let exchangeEndpoint = process.env.VUE_APP_GS_TOKEN_URL;

    if (uuid?.startsWith('P')) {
        exchangeEndpoint = exchangeEndpoint.replace('gs-staging', 'grainstation');
    }

    try {
        const response = await fetch(`${exchangeEndpoint}/${uuid}`, {
            method: 'GET'
        });

        const data = await response.json();
        if (data && data.data && data.data.accessToken) {
            return data.data.accessToken;
        }
    } catch (error) {
        throw error;
    }
}

async function keycloakImpersonate(jwtToken, userId) {
    const keycloakBaseUrl = process.env.VUE_APP_KEYCLOAK_AUTH_URL;
    const realm = process.env.VUE_APP_KEYCLOAK_REALM;
    const impersonateEndpoint = `${keycloakBaseUrl}/admin/realms/${realm}/users/${userId}/impersonation`;

    localStorage.setItem('hidden_menu', 'true');

    try {
        await fetch(impersonateEndpoint, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${jwtToken}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        });
    } catch (error) {
        throw error;
    }
}

// This function removes specific query parameters from the URL
// without reloading the page, which is useful for cleaning up URLs after processing.
// @param {Array<string>} paramsToRemove - An array of parameter names to remove from the URL.
function cleanUrl(paramsToRemove) {
    const url = new URL(window.location.href);

    if (url.hash) {
        return removeHashQueryParamsIfPresent(paramsToRemove);
    }

    paramsToRemove.forEach(param => url.searchParams.delete(param));

    window.history.replaceState(null, '', url.toString());
}

function removeHashQueryParamsIfPresent(paramsToRemove) {
    const [base, hash] = window.location.href.split('#');

    if (!hash) {
        return;
    }

    const [route, queryString] = hash.split('?');
    const searchParams = new URLSearchParams(queryString);

    let changed = false;

    paramsToRemove.forEach(param => {
        if (searchParams.has(param)) {
            searchParams.delete(param);
            changed = true;
        }
    });

    if (changed) {
        const newHash = searchParams.toString()
            ? `${route}?${searchParams.toString()}`
            : route;

        const newUrl = `${base}#${newHash}`;
        window.history.replaceState({}, '', newUrl);
    }
}

let impersonationHandled = false;

export async function handleImpersonationFlow() {
    if (impersonationHandled) return;
    impersonationHandled = true;

    const uuid = getQueryParam('opaqueToken');
    const userId = getQueryParam('userId');

    if (!uuid || !userId) {
        return;
    }

    cleanUrl(['userId', 'opaqueToken']);
    
    localStorage.setItem('hidden_menu', 'false');

    const jwt = await getJwtToken(uuid);
    await keycloakImpersonate(jwt, userId);
}
